import TransitApi from './base'

export default {
  async create(payload) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/app/shipments', payload)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params || {})
      const result = await Api.get(`/app/shipments?${queryString}`)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getById(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/app/shipments/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },

  async update(id, payload) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.put(`/app/shipments/${id}`, payload)
      return result
    } catch (error) {
      return error.response
    }
  },

  async assignMessenger(id, assignedUserId, comment) {
    try {
      const Api = TransitApi.getSecureInstance()
      const payload = { assigned_user_id: assignedUserId }
      if (comment) payload.comment = comment
      const result = await Api.post(`/app/shipments/${id}/assign`, payload)
      return result
    } catch (error) {
      return error.response
    }
  },

  async changeStatus(id, status, comment) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/app/shipments/${id}/change-status`, {
        new_status: status,
        comment,
      })
      return result
    } catch (error) {
      return error.response
    }
  },

  // Iniciar viaje: asignado -> en_transito + activa el mapa en vivo
  async startTrip(id, payload = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/app/shipments/${id}/start-trip`, payload)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Bitácora del envío (pasos con progreso y evidencias)
  async getBitacora(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/app/shipments/${id}/bitacora`)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getTracking(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/app/shipments/${id}/tracking`)
      return result
    } catch (error) {
      return error.response
    }
  },

  async completeStep(id, stepId, data) {
    try {
      return await TransitApi.getSecureInstanceMultipart().post(
        `/app/shipments/${id}/bitacora/${stepId}/complete`,
        data
      )
    } catch (error) {
      return error.response
    }
  },

  async liveLocation(id, coords) {
    return TransitApi.getSecureInstance().post(
      `/app/shipments/${id}/live-location`,
      coords
    )
  },
}
